type OrderItem = {
  product?: { Image?: string | null } | null;
};

/** Extracts deduplicated product image URLs from order items. */
export function getUniqueOrderImages(orderItems: OrderItem[]): string[] {
  return [...new Set(orderItems.map((item) => item.product?.Image).filter((img): img is string => Boolean(img)))];
}
